
// Flow diagram data structure
export const FLOW_DATA = {
    resilienceOutcomes: [
      { id: 'yield', name: 'Protected/Improved Yields', color: '#6B7280' },
      { id: 'cost', name: 'Reduced Costs', color: '#6B7280' },
      { id: 'income', name: 'Diversified Income', color: '#6B7280' },
      { id: 'price', name: 'Increased Product Price', color: '#6B7280' },
      { id: 'shocks', name: 'Protection from Economic & Environmental Shocks', color: '#6B7280' }
    ],
    
    natureOutcomes: [
      { id: 'pollinators', name: 'High Pollinator Abundance', color: '#6B7280', connects: ['yield','cost'] },
      { id: 'water_efficiency', name: 'Water Efficiency', color: '#6B7280', connects: ['shocks','cost','yield'] },
      { id: 'biodiversity', name: 'Overall Species Diversity', color: '#6B7280', connects: ['yield', 'price','income','shocks'] },
      { id: 'carbon_storage', name: 'Increased Carbon Sequestration', color: '#6B7280', connects: ['price', 'income'] },
      { id: 'emissions', name: 'Reduce Fossil Fuel Use', color: '#6B7280', connects: ['price', 'income'] },
      { id: 'pest_control', name: 'Natural Predator Abundance', color: '#6B7280', connects: ['yield', 'cost','shocks'] },
      { id: 'water_quality', name: 'Improved Water Quality', color: '#6B7280', connects: ['price','yield'] },
      { id: 'nutrient_efficiency', name: 'Improved Nutrient Use Efficiency', color: '#6B7280', connects: ['cost','yield','shocks','income'] },
      { id: 'soc', name: 'Increased Soil Organic Carbon', color: '#6B7280', connects: ['cost','yield','price','income'] },
      { id: 'som', name: 'Increased Soil Organic Matter', color: '#6B7280', connects: ['cost','yield','price','income'] },
      { id: 'soil_fertility', name: 'Increased Soil Fertility', color: '#6B7280', connects: ['cost','yield','shocks'] },
      { id: 'soil_compaction', name: 'Reduced Soil Compaction', color: '#6B7280', connects: ['yield','shocks'] },
      { id: 'soil_erosion', name: 'Reduced Soil Erosion', color: '#6B7280', connects: ['yield','shocks'] },
      { id: 'soil_biology', name: 'Enhance Active Soil Biology', color: '#6B7280', connects: ['yield','shocks'] },
      { id: 'landscape_resilience', name: 'Landscape Resilience to Extreme Weather', color: '#6B7280', connects: ['yield','shocks'] },
      { id: 'reduced_waste', name: 'Reduce Waste', color: '#6B7280', connects: ['cost'] },
    ],
    
    farmActions: [
      { id: 'wildflower_strips', name: 'Wildflower Field Margins', connects: ['pollinators', 'biodiversity','pest_control'] },
      { id: 'field_margins', name: 'Grass Field Margins', connects: ['pollinators', 'pest_control'] },
      { id: 'cover_crops', name: 'Winter Cover Crops', connects: ['water_efficiency','soil_compaction','soil_erosion','som','soil_fertility','soc'] },
      // { id: 'agroforestry', name: 'Agroforestry', connects: ['carbon_storage', 'biodiversity', 'soil_fertility','som'] },
      // { id: 'field_margins', name: 'Grass Field Margins', connects: ['pollinators', 'pest_control'] },
      { id: 'no_till', name: 'No-Till Farming', connects: [ 'water_efficiency','soil_erosion','soil_compaction','soil_fertility','soil_biology','som','soc'] },
      { id: 'crop_rotation', name: 'Crop Rotation', connects: ['pest_control','som','nutrient_efficiency','soil_fertility','soil_compaction','soil_biology'] },
      { id: 'hedgerows', name: 'Hedgerows', connects: ['biodiversity', 'carbon_storage','water_efficiency','water_quality','soil_erosion','pest_control','pollinators','soc'] },
      { id: 'organic_inputs', name: 'Organic Matter Inputs', connects: ['soil_fertility','som','soil_biology','reduced_waste'] },
      { id: 'renewable_energy', name: 'Adopt Renewable Energy', connects: ['emissions'] },
      { id: 'ridging', name: 'Ridging', connects: ['soil_erosion','water_efficiency'] },
      { id: 'contour_farming', name: 'Contour Farming', connects: ['landscape_resilience','nutrient_efficiency','water_quality','soil_erosion','water_efficiency'] },
      { id: 'hydrophilic_crops', name: 'Grow Hydrophilic Crops', connects: ['landscape_resilience','water_quality','soil_erosion','water_efficiency','soil_compaction'] },
      { id: 'water_harvesting', name: 'Water Harvesting', connects: ['soil_erosion','water_efficiency','reduced_waste'] },
      { id: 'surface_drainage', name: 'Surface Drainage', connects: ['soil_erosion','water_efficiency','water_quality'] },
      { id: 'subsurface_drainage', name: 'Subsurface Drainage', connects: ['soil_erosion','water_efficiency','water_quality'] },
      { id: 'machinery_optimisation', name: 'Optimise Machinery Use & Maintenance', connects: ['reduced_waste','emissions'] },
      { id: 'intercropping', name: 'Intercropping', connects: ['soil_fertility','soil_erosion','som'] },
      { id: 'minimum_herbicide', name: 'Minimise Chemical Inputs', connects: ['nutrient_efficiency','water_quality','soil_fertility','soil_biology','pollinators','pest_control','som'] },
      { id: 'crop_residue', name: 'Crop Residue', connects: ['soil_biology','soil_erosion','soil_compaction','soil_fertility','water_efficiency','reduced_waste','som','soc'] },
      { id: 'habitat_restoration', name: 'Species Rich Grassland', connects: ['landscape_resilience','carbon_storage','biodiversity','soc'] },
      { id: 'buffer_zones', name: 'Natural Buffer Zones', connects: ['landscape_resilience','biodiversity','pollinators','pest_control','water_quality','water_efficiency'] },
      // { id: 'soil_amendment', name: 'Soil Amendments', connects: ['soil_fertility','som','soil_biology','soil_compaction','nutrient_efficiency','soc'] },
      { id: 'farm_waste_management', name: 'Farm Waste Management', connects: ['reduced_waste','emissions','water_quality','som'] },
      { id: 'precision_irrigation', name: 'Irrigation Management', connects: ['water_efficiency','nutrient_efficiency','soil_erosion','water_quality'] },
      { id: 'greywater_recycling', name: 'Greywater Recycling', connects: ['water_efficiency','reduced_waste','water_quality'] },
      // { id: 'ghg_monitoring', name: 'Farm Carbon Footprint Monitoring', connects: ['emissions','carbon_storage'] },
      { id: 'woodland', name: 'Woodland Planting', connects: ['carbon_storage','biodiversity','landscape_resilience','soc'] },
      { id: 'unharvested_headlands', name: 'Unharvested Conservation Headlands', connects: ['biodiversity','pollinators','pest_control']},
      { id: 'stubbles_green_manure', name: 'Stubbles Followed by Green Manure', connects: ['soil_fertility','soil_erosion','soil_compaction','biodiversity','soc','som']},
      
    ]
  };
  // Updated MRV_ACTION_DATA with detailed hover explanations
export const MRV_ACTION_DATA = {
  wildflower_strips: {
    satelliteVerification: 'high',
    satelliteVerifiable: true,
    explanation: {
      reason: "Wildflower strips create distinct vegetation signatures with clear spectral differences from surrounding crops, making them easily identifiable from space.",
      dataTypes: "High-resolution optical imagery (0.5-1m), multispectral bands. Time-series helpful to distinguish from weeds and track establishment success.",
      frequency: "Seasonal monitoring (spring establishment, summer flowering, autumn senescence)",
      timeSeries: "Time-series helpful to distinguish from weeds and track establishment success"
    }
  },
  
  cover_crops: {
    satelliteVerification: 'high',
    satelliteVerifiable: true,

    explanation: {
      reason: "Cover crops are highly visible as green vegetation during typical fallow periods when main crops are absent, creating clear temporal signatures.",
      dataTypes: "Medium-resolution multispectral imagery (Sentinel-2, 10-20m), NDVI time-series. Time-series essential to verify presence during off-season and track growth cycles.",
      frequency: "Monthly monitoring during cover crop season (autumn planting to spring termination)",
      timeSeries: "Time-series essential to verify presence during off-season and track growth cycles"
    }
  },

  // agroforestry: {
  //   satelliteVerification: 'high',
  //   explanation: {
  //     reason: "Trees create distinctive canopy structures with unique height profiles that are easily distinguished from agricultural crops.",
  //     dataTypes: "High-resolution optical imagery (0.3-1m), stereo pairs and/or LiDAR for height data. Time-series useful for monitoring tree establishment and growth but not essential for detection.",
  //     frequency: "Annual monitoring sufficient for mature trees, quarterly for new plantings",
  //     timeSeries: "Time-series useful for monitoring tree establishment and growth but not essential for detection"
  //   }
  // },

  field_margins: {
    satelliteVerification: 'high',
    satelliteVerifiable: true,

    explanation: {
      reason: "Field margins appear as linear features with different vegetation signatures along field boundaries, clearly visible in high-resolution imagery.",
      dataTypes: "High-resolution optical imagery (0.3-1m), edge detection algorithms. Time-series helpful to monitor margin development and maintenance over time.",
      frequency: "Bi-annual monitoring (spring and summer) to track vegetation establishment",
      timeSeries: "Time-series helpful to monitor margin development and maintenance over time"
    }
  },

  no_till: {
    satelliteVerification: 'medium',
    satelliteVerifiable: true,

    explanation: {
      reason: "No-till practices leave crop residue on the surface which can be detected through spectral analysis, but requires specialized algorithms and ground validation for confirmation.",
      dataTypes: "Multispectral imagery with specific residue indices, SAR data for surface roughness. Time-series crucial to track residue persistence and distinguish from conventional tillage.",
      frequency: "Post-harvest and pre-planting monitoring (2-3 times per year)",
      timeSeries: "Time-series crucial to track residue persistence and distinguish from conventional tillage"
    }
  },

  crop_rotation: {
    satelliteVerification: 'medium',
    satelliteVerifiable: false,

    explanation: {
      reason: "Crop rotation is detectable through different spectral signatures of various crops, but requires multi-year data and sophisticated classification algorithms.",
      dataTypes: "Medium-resolution multispectral imagery, crop classification algorithms. Multi-year time-series essential to verify rotation patterns and crop diversity.",
      frequency: "Seasonal monitoring throughout growing seasons",
      timeSeries: "Multi-year time-series essential to verify rotation patterns and crop diversity"
    }
  },

  hedgerows: {
    satelliteVerification: 'medium',
    satelliteVerifiable: true,

    explanation: {
      reason: "Established hedgerows are easily visible as linear woody features, but young or sparse hedgerows may be difficult to distinguish from other vegetation.",
      dataTypes: "High-resolution optical imagery (0.3-0.5m), LiDAR for height verification. Time-series not essential for detection but useful for future monitoring.",
      frequency: "Annual monitoring for mature hedgerows, quarterly for new plantings",
      timeSeries: "Time-series valuable for monitoring establishment success and growth over multiple years"
    }
  },

  organic_inputs: {
    satelliteVerification: 'low',
    satelliteVerifiable: false,

    explanation: {
      reason: "Organic matter application cannot be directly observed from space.",
      dataTypes: "N/A",
      frequency: "Post-application monitoring (monthly for 3-6 months after application)",
      timeSeries: "Time-series required to detect gradual vegetation response changes, but highly uncertain"
    }
  },

  renewable_energy: {
    satelliteVerification: 'low',
    satelliteVerifiable: false,

    explanation: {
      reason: "While solar panels and wind turbines are highly visible structures, this category may refer to energy-efficient practices that don't create visible infrastructure changes.",
      dataTypes: "High-resolution optical imagery for infrastructure detection",
      frequency: "Annual monitoring for infrastructure changes",
      timeSeries: "Single-date imagery sufficient for infrastructure, time-series not typically needed"
    }
  },

  ridging: {
    satelliteVerification: 'medium',
    satelliteVerifiable: true,

    explanation: {
      reason: "Ridge and furrow patterns create distinct topographic and drainage signatures visible in imagery, but may be confused with natural terrain variations.",
      dataTypes: "High-resolution optical imagery, digital elevation models, SAR for texture analysis",
      frequency: "Post-implementation monitoring (immediately after ridging, then seasonal)",
      timeSeries: "Time-series helpful to monitor ridge persistence and effectiveness over seasons"
    }
  },

  contour_farming: {
    satelliteVerification: 'high',
    satelliteVerifiable: true,

    explanation: {
      reason: "Contour farming creates distinctive curved field patterns that follow topographic lines, easily visible in satellite imagery as organized curved strips.",
      dataTypes: "Medium-resolution optical imagery (10-20m), digital elevation models for verification",
      frequency: "Annual monitoring during growing season when crop patterns are most visible",
      timeSeries: "Single-season imagery often sufficient, time-series useful for monitoring consistency"
    }
  },

  hydrophilic_crops: {
    satelliteVerification: 'medium',
    satelliteVerifiable: false,

    explanation: {
      reason: "Water-loving crops can be identified through their spectral signatures and location in wet areas, but require knowledge of local crop varieties and growing conditions.",
      dataTypes: "Multispectral imagery with water indices, crop classification algorithms",
      frequency: "Seasonal monitoring throughout growing season",
      timeSeries: "Time-series valuable to track crop phenology and distinguish from other water-tolerant vegetation"
    }
  },

  water_harvesting: {
    satelliteVerification: 'low',
    satelliteVerifiable: false,

    explanation: {
      reason: "Small-scale water harvesting infrastructure (tanks, ponds) may be below satellite resolution limits. Larger installations are visible but require high-resolution imagery.",
      dataTypes: "Very high-resolution optical imagery (0.3-0.5m), SAR for water detection",
      frequency: "Annual monitoring for infrastructure changes, seasonal for water levels",
      timeSeries: "Time-series useful for monitoring water storage patterns but not essential for infrastructure detection"
    }
  },

  surface_drainage: {
    satelliteVerification: 'medium',
    satelliteVerifiable: false,

    explanation: {
      reason: "Surface drainage channels and ditches are visible in high-resolution imagery as linear water features, but may be confused with natural waterways.",
      dataTypes: "High-resolution optical imagery, SAR for water body detection, elevation models",
      frequency: "Bi-annual monitoring (wet and dry seasons) to verify drainage functionality",
      timeSeries: "Time-series helpful to monitor seasonal drainage patterns and maintenance"
    }
  },

  subsurface_drainage: {
    satelliteVerification: 'low',
    satelliteVerifiable: false,

    explanation: {
      reason: "Underground drainage systems are not directly visible from space. Only indirect effects like improved crop health in previously waterlogged areas might be detectable.",
      dataTypes: "Multispectral imagery for vegetation health analysis, soil moisture indices",
      frequency: "Seasonal monitoring during wet periods to assess drainage effectiveness",
      timeSeries: "Multi-year time-series essential to detect subtle improvements in crop performance and soil conditions"
    }
  },

  machinery_optimisation: {
    satelliteVerification: 'low',
    satelliteVerifiable: false,

    explanation: {
      reason: "Machinery optimization practices (maintenance, fuel efficiency) create no visible landscape changes. Cannot be detected through satellite imagery.",
      dataTypes: "No applicable satellite data types",
      frequency: "Not applicable for satellite monitoring",
      timeSeries: "Satellite verification not feasible - requires farm records and on-site verification"
    }
  },

  intercropping: {
    satelliteVerification: 'medium',
    satelliteVerifiable: false,

    explanation: {
      reason: "Mixed crop patterns can be detected through spectral analysis when crops have different phenologies, but requires high spatial resolution and sophisticated algorithms.",
      dataTypes: "High-resolution multispectral imagery (1-5m), crop classification algorithms",
      frequency: "Frequent monitoring throughout growing season (bi-weekly to monthly)",
      timeSeries: "Time-series essential to distinguish mixed cropping patterns from monocultures and track different crop phenologies"
    }
  },

  minimum_herbicide: {
    satelliteVerification: 'low',
    satelliteVerifiable: false,

    explanation: {
      reason: "Reduced chemical inputs cannot be directly observed from space. Only indirect effects like increased weed presence or changed vegetation patterns might be detectable.",
      dataTypes: "High-resolution multispectral imagery for weed detection, vegetation health indices",
      frequency: "Regular monitoring throughout growing season (monthly)",
      timeSeries: "Time-series required to establish baseline and detect gradual changes in field vegetation patterns"
    }
  },

  crop_residue: {
    satelliteVerification: 'high',
    satelliteVerifiable: true,
    explanation: {
      reason: "Crop residue on field surfaces creates distinct spectral signatures that can be reliably detected and quantified using specialized residue indices.",
      dataTypes: "Multispectral imagery with crop residue indices (NDTI, STI), thermal imagery",
      frequency: "Post-harvest monitoring for several months until next planting",
      timeSeries: "Time-series valuable to track residue decomposition rates and coverage persistence"
    }
  },

  habitat_restoration: {
    satelliteVerification: 'high',
    satelliteVerifiable: true,

    explanation: {
      reason: "Converting agricultural land to natural habitat creates clear land use changes with distinct vegetation signatures easily visible in satellite imagery.",
      dataTypes: "Medium to high-resolution multispectral imagery, land use classification algorithms",
      frequency: "Annual monitoring to track restoration progress",
      timeSeries: "Multi-year time-series valuable to monitor establishment success and ecosystem development"
    }
  },

  buffer_zones: {
    satelliteVerification: 'high',
    satelliteVerifiable: true,

    explanation: {
      reason: "Buffer strips along waterways appear as linear vegetation features with different spectral signatures from surrounding crops, clearly visible in imagery.",
      dataTypes: "High-resolution optical imagery (0.5-2m), multispectral bands for vegetation analysis",
      frequency: "Bi-annual monitoring (spring and summer) for vegetation establishment and health",
      timeSeries: "Time-series helpful to monitor buffer zone development and maintenance over time"
    }
  },

  woodland: {
    satelliteVerification: 'high',
    satelliteVerifiable: true,

    explanation: {
      reason: "Planting woodland is easily visible from satellite imagery.",
      dataTypes: "",
      frequency: "",
      timeSeries: "Time-series helpful to monitor woodland development and maintenance over time"
    }
  },

  unharvested_headlands: {
    satelliteVerification: 'high',
    satelliteVerifiable: true,

    explanation: {
      reason: "",
      dataTypes: "",
      frequency: "",
      timeSeries: ""
    }
  },

  farm_waste_management: {
    satelliteVerification: 'high',
    satelliteVerifiable: false,

    explanation: {
      reason: "",
      dataTypes: "",
      frequency: "",
      timeSeries: ""
    }
  },
  precision_irrigation: {
    satelliteVerification: 'high',
    satelliteVerifiable: false,

    explanation: {
      reason: "",
      dataTypes: "",
      frequency: "",
      timeSeries: ""
    }
  },
  stubbles_green_manure: {
    satelliteVerification: 'high',
    satelliteVerifiable: false,

    explanation: {
      reason: "",
      dataTypes: "",
      frequency: "",
      timeSeries: ""
    }
  },
  greywater_recycling: {
    satelliteVerification: 'high',
    satelliteVerifiable: false,

    explanation: {
      reason: "",
      dataTypes: "",
      frequency: "",
      timeSeries: ""
    }
  },

  // soil_amendments: {
  //   satelliteVerification: 'high',
  //   satelliteVerifiable: false,
  //   explanation: {
  //     reason: "",
  //     dataTypes: "",
  //     frequency: "",
  //     timeSeries: ""
  //   }
  // }

};
  
// Updated MRV data for nature outcomes - your existing data with in-situ verification added
export const MRV_NATURE_DATA = {
  pollinators: {
    inSituVerification: 'sensing',
    explanation: {
      reason: "Uses automated bioacoustics and computer vision systems for continuous pollinator detection and counting.",
      dataTypes: "Audio sensors, camera traps, eDNA sampling, IoT devices",
      frequency: "Continuous during flowering season",
      timeSeries: "Time-series essential for tracking species abundance and activity patterns"
    },
    monitoringMethods: [
      'Bioacoustics',
      'Image + computer vision systems for pollinator counting',
    ],
    technologies: ['Audio sensors', 'Camera traps', 'eDNA sampling', 'IoT devices'],
    frequency: 'Continuous during flowering season',
    dataTypes: 'Species abundance, diversity indices, activity patterns',
    accuracy: 'High for common species, medium for rare species'
  },

  water_efficiency: {
    inSituVerification: 'sampling',
    explanation: {
      reason: "Currently relies on farmer records which require manual data collection and verification.",
      dataTypes: "Farmer records, potential for moisture sensors and flow meters",
      frequency: "Continuous monitoring with daily reporting",
      timeSeries: "Time-series valuable for tracking water usage efficiency over time"
    },
    monitoringMethods: [
      'Farmer records'
    ],
    technologies: ['Moisture sensors', 'Satellite data', 'Flow meters', 'Thermal cameras'],
    frequency: 'Continuous monitoring with daily reporting',
    dataTypes: 'Water usage, soil moisture levels, crop water stress',
    accuracy: 'High with calibrated sensor networks'
  },

  biodiversity: {
    inSituVerification: 'sensing',
    explanation: {
      reason: "Uses automated bioacoustic monitoring, camera traps, and eDNA sampling for continuous species detection.",
      dataTypes: "Audio recorders, camera traps, eDNA analysis, AI classification",
      frequency: "Continuous automated monitoring",
      timeSeries: "Long-term time-series crucial for biodiversity trend detection"
    },
    monitoringMethods: [
      'Bioacoustic monitoring for bird and insect species',
      'Camera traps for mammal and bird observations',
      'Environmental DNA sampling from soil and water',
    ],
    technologies: ['Audio recorders', 'Camera traps', 'eDNA analysis', 'AI classification'],
    frequency: 'Continuous automated monitoring',
    dataTypes: 'Species counts, diversity metrics, habitat quality',
    accuracy: 'High for vertebrates, improving for invertebrates'
  },

  carbon_storage: {
    inSituVerification: 'sampling',
    explanation: {
      reason: "Requires soil carbon sampling and laboratory analysis, though enhanced by LiDAR and satellite data.",
      dataTypes: "Soil sampling, spectroscopy, LiDAR, flux towers, laboratory analysis",
      frequency: "Annual soil sampling, continuous flux monitoring",
      timeSeries: "Long-term monitoring essential for carbon accumulation trends"
    },
    monitoringMethods: [
      'Biomass estimation using LiDAR and satellite data',
    ],
    technologies: ['Spectroscopy', 'LiDAR', 'Flux towers', 'Laboratory analysis'],
    frequency: 'Annual soil sampling, continuous flux monitoring',
    dataTypes: 'Soil organic carbon, biomass carbon, net carbon flux',
    accuracy: 'Very high with validated measurement protocols'
  },

  emissions: {
    inSituVerification: 'sampling',
    explanation: {
      reason: "Currently relies on farmer records for tracking energy use and emissions data.",
      dataTypes: "Farmer records, smart meters, GPS tracking, gas sensors",
      frequency: "Continuous monitoring with real-time reporting",
      timeSeries: "Time-series important for emission reduction tracking"
    },
    monitoringMethods: [
      'Farmer records',
    ],
    technologies: ['Smart meters', 'GPS tracking', 'Gas sensors', 'Software systems'],
    frequency: 'Continuous monitoring with real-time reporting',
    dataTypes: 'Energy use, fuel consumption, GHG emissions',
    accuracy: 'Very high with calibrated equipment'
  },

  pest_control: {
    inSituVerification: 'sensing',
    explanation: {
      reason: "Uses automated bioacoustic detection and drone surveys for continuous pest and predator monitoring.",
      dataTypes: "Smart traps, audio sensors, drone imaging, weather stations",
      frequency: "Daily trap monitoring, weekly surveys during peak season",
      timeSeries: "Seasonal monitoring essential for pest-predator dynamics"
    },
    monitoringMethods: [
      'Bioacoustic detection of beneficial predator species (birds/bats)',
      'Multispectral satellite/drone imaging for pest stress',
    ],
    technologies: ['Smart traps', 'Audio sensors', 'Drone imaging', 'Weather stations'],
    frequency: 'Daily trap monitoring, weekly surveys during peak season',
    dataTypes: 'Pest counts, damage assessment, predator abundance',
    accuracy: 'High with species-specific detection algorithms'
  },

  water_quality: {
    inSituVerification: 'sensing',
    explanation: {
      reason: "Uses IoT water quality sensors for continuous monitoring with periodic laboratory validation.",
      dataTypes: "Water quality probes, satellite imagery, laboratory analysis, IoT sensors",
      frequency: "Continuous sensor monitoring with monthly lab validation",
      timeSeries: "High-frequency monitoring essential for water quality trends"
    },
    monitoringMethods: [
      'IoT water quality sensors',
      'Water sampling',
    ],
    technologies: ['Water quality probes', 'Satellite imagery', 'Laboratory analysis', 'IoT sensors'],
    frequency: 'Continuous sensor monitoring with monthly lab validation',
    dataTypes: 'Nutrient levels, turbidity, pH, dissolved oxygen',
    accuracy: 'Very high with calibrated probe networks'
  },

  nutrient_efficiency: {
    inSituVerification: 'sensing',
    explanation: {
      reason: "Uses soil NPK sensors for real-time monitoring combined with satellite-based crop health assessment.",
      dataTypes: "Soil sensors, farmer records, satellite NDVI data",
      frequency: "Continuous sensor monitoring with seasonal sampling",
      timeSeries: "Time-series crucial for nutrient optimization"
    },
    monitoringMethods: [
      'Soil NPK sensors for real-time monitoring',
      'Farmer records',
      'Satellite-based crop health monitoring (NDVI)'
    ],
    technologies: ['Soil sensors', 'Laboratory analysis', 'Precision ag equipment', 'Satellite data'],
    frequency: 'Continuous sensor monitoring with seasonal tissue sampling',
    dataTypes: 'Soil nutrient levels, plant nutrition status, uptake efficiency',
    accuracy: 'High with regular calibration and validation'
  },

  som: {
    inSituVerification: 'sampling',
    explanation: {
      reason: "Requires soil core sampling and laboratory testing for accurate organic matter quantification.",
      dataTypes: "Soil cores, NIR spectroscopy, laboratory analysis",
      frequency: "Annual comprehensive sampling with continuous monitoring",
      timeSeries: "Long-term monitoring required for soil organic matter changes"
    },
    monitoringMethods: [
      'Soil sampling and laboratory testing',
      'Potential satellite proxies'    ],
    technologies: ['NIR spectroscopy', 'Laboratory analysis', 'Satellite data', 'Carbon sensors'],
    frequency: 'Annual comprehensive sampling with continuous monitoring',
    dataTypes: 'Soil organic matter content, carbon:nitrogen ratios',
    accuracy: 'Very high with laboratory validation'
  },

  soc: {
    inSituVerification: 'sampling',
    explanation: {
      reason: "Requires soil core sampling and laboratory testing for accurate organic matter quantification.",
      dataTypes: "Soil cores, NIR spectroscopy, laboratory analysis",
      frequency: "Annual comprehensive sampling with continuous monitoring",
      timeSeries: "Long-term monitoring required for soil organic matter changes"
    },
    monitoringMethods: [
      'Soil sampling and laboratory testing',
      'Potential satellite proxies',
      'Soil carbon modelling - soil pH, temperature & moisture sensors'
    ],
    technologies: ['NIR spectroscopy', 'Laboratory analysis', 'Satellite data', 'Carbon sensors'],
    frequency: 'Annual comprehensive sampling with continuous monitoring',
    dataTypes: 'Soil organic matter content, carbon:nitrogen ratios',
    accuracy: 'Very high with laboratory validation'
  },

  soil_fertility: {
    inSituVerification: 'sensing',
    explanation: {
      reason: "Uses automated soil NPK, temperature & moisture sensors combined with satellite monitoring for continuous assessment.",
      dataTypes: "Soil sensors, laboratory testing, yield monitors, satellite NDVI",
      frequency: "Continuous sensor monitoring with seasonal lab testing",
      timeSeries: "Time-series valuable for fertility trend monitoring"
    },
    monitoringMethods: [
      'Soil NPK, temperature & moisture sensors',
      'Soil sampling and laboratory analysis',
      'Plant health assessment through satellite NDVI'
    ],
    technologies: ['Soil sensors', 'Laboratory testing', 'Yield monitors', 'Spectral analysis'],
    frequency: 'Continuous sensor monitoring with seasonal lab testing',
    dataTypes: 'Nutrient availability, pH, organic matter, yield response',
    accuracy: 'Very high with comprehensive testing protocols'
  },

  soil_compaction: {
    inSituVerification: 'sampling',
    explanation: {
      reason: "No current monitoring methods specified - would require manual measurements with penetrometers.",
      dataTypes: "Penetrometers, GPR, pressure sensors, root imaging",
      frequency: "Seasonal measurements with event-based monitoring",
      timeSeries: "Time-series valuable for compaction pattern tracking"
    },
    monitoringMethods: ['Bulk density test',
      'Soil moisture sensors as proxy',
      'Soil moisture from satellite as proxy'
    ],
    technologies: ['Penetrometers', 'GPR', 'Pressure sensors', 'Root imaging'],
    frequency: 'Seasonal measurements with event-based monitoring',
    dataTypes: 'Soil bulk density, penetration resistance, root development',
    accuracy: 'High with calibrated equipment'
  },

  soil_erosion: {
    inSituVerification: 'sampling',
    explanation: {
      reason: "No current monitoring methods specified - would require manual measurement and periodic surveys.",
      dataTypes: "Physical measurement, drone surveys, sediment monitoring",
      frequency: "Post-storm event monitoring with seasonal assessments",
      timeSeries: "Time-series essential for erosion event capture"
    },
    monitoringMethods: ['Erosion-prone areas can be mapped with satellite imagery',
      'LiDAR & DEMs'
    ],
    technologies: ['Physical measurement', 'Drone surveys', 'Sediment monitoring', 'Satellite data'],
    frequency: 'Post-storm event monitoring with seasonal assessments',
    dataTypes: 'Soil loss rates, topographic changes, sediment loads',
    accuracy: 'High with multiple measurement methods'
  },

  soil_biology: {
    inSituVerification: 'sampling',
    explanation: {
      reason: "Uses earthworm surveys, soil respiration systems, and eDNA sampling requiring manual collection and analysis.",
      dataTypes: "Field surveys, respiration chambers, DNA sequencing, laboratory assays",
      frequency: "Seasonal sampling with continuous respiration monitoring",
      timeSeries: "Annual monitoring important for biological health tracking"
    },
    monitoringMethods: [
      'Earthworm & ground beetle population surveys',
      'Soil respiration measurement systems',
      'eDNA'
    ],
    technologies: ['DNA sequencing', 'Laboratory assays', 'Field surveys', 'Respiration chambers'],
    frequency: 'Seasonal sampling with continuous respiration monitoring',
    dataTypes: 'Microbial diversity, enzyme activity, fauna abundance',
    accuracy: 'High with standardized protocols'
  },

  landscape_resilience: {
    inSituVerification: 'sensing',
    explanation: {
      reason: "Uses automated weather stations and satellite-based monitoring for continuous landscape assessment.",
      dataTypes: "Weather stations, satellite monitoring, hydrological models, GIS analysis",
      frequency: "Continuous weather monitoring with annual assessments",
      timeSeries: "Long-term monitoring crucial for resilience pattern assessment"
    },
    monitoringMethods: [
      'Weather stations for microclimate monitoring',
      'Habitat mapping & condition monitoring through satellite multispectral imagery',
      'Biodiversity corridor mapping and connectivity analysis through DEMs/LiDAR'
    ],
    technologies: ['Weather stations', 'Satellite monitoring', 'Hydrological models', 'GIS analysis'],
    frequency: 'Continuous weather monitoring with annual resilience assessments',
    dataTypes: 'Climate resilience indices, vegetation recovery rates',
    accuracy: 'Medium to high depending on scale and indicators'
  },

  reduced_waste: {
    inSituVerification: 'low',
    explanation: {
      reason: "Currently relies on farmer records which require manual tracking and verification.",
      dataTypes: "Farmer records, automated scales, digital systems, IoT sensors",
      frequency: "Continuous monitoring with monthly reporting",
      timeSeries: "Time-series valuable for waste reduction trend tracking"
    },
    monitoringMethods: [
      'Farmer records',
    ],
    technologies: ['Automated scales', 'Digital systems', 'IoT sensors', 'Software analytics'],
    frequency: 'Continuous monitoring with monthly reporting',
    dataTypes: 'Waste volumes, input efficiency, resource utilization',
    accuracy: 'Very high with automated tracking systems'
  }
};
  // Farm action data with economic impacts
export const FARM_ACTION_DATA = {
    wildflower_strips: {
      name: 'Wildflower Field Margins',
      unit: 'ha',
      costSavings: 25,
      implementationCost: 500,
      maintenanceCost:100,

      benefits: ['Increased pollination', 'Biodiversity habitat', 'Soil erosion prevention', 'Natural pest control'],
      longTermPros: ['Enhanced ecosystem resilience', 'Reduced pesticide dependency', 'Carbon sequestration', 'Water quality improvement'],
      SAIQ: ['FSA68b'],
      aecs: true,
      AECSpayment_yr1: 1142.97,
      AECSpayment_yr2: 811.46,    // Year 2 payment per unit
      AECSpayment_yr3: 811.46,    // Year 3 payment per unit
      AECSpayment_yr4: 811.46,    // Year 4 payment per unit
      AECSpayment_yr5: 811.46, 
    },

    wildbird_seed: {
      name: 'Wildbird Seed Mix',
      unit: 'ha',
      costSavings: 0,
      implementationCost: 500,
      maintenanceCost:0,

      benefits: ['Increased pollination', 'Biodiversity habitat', 'Soil erosion prevention', 'Natural pest control'],
      longTermPros: ['Enhanced ecosystem resilience', 'Reduced pesticide dependency', 'Carbon sequestration', 'Water quality improvement'],
      SAIQ: ['FSA68a','FSA68b'],
      aecs: true,
      AECSpayment_yr1: 554.97,
      AECSpayment_yr2: 322.63,    // Year 2 payment per unit
      AECSpayment_yr3: 322.63,    // Year 3 payment per unit
      AECSpayment_yr4: 322.63,    // Year 4 payment per unit
      AECSpayment_yr5: 322.63, 
      AECS_maxarea: 5  
    },

    cover_crops: {
      name: 'Winter Cover Crops',
      unit: 'ha',
      costSavings: 20,
      implementationCost: 0,
      maintenanceCost:120,

      benefits: ['Improved soil fertility', 'Reduced erosion', 'Weed suppression', 'Nitrogen fixation'],
      longTermPros: ['Enhanced soil organic matter', 'Improved water retention', 'Better soil structure', 'Reduced fertilizer needs'],
      SAIQ:['FSA28a','FSA28b','FSA29b','FSA36'],
      aecs: false,
      carbon:true,
      carbonPayment_yr1: 12,
      carbonPayment_yr2: 12,
      carbonPayment_yr3: 12,
      carbonPayment_yr4: 12,
      carbonPayment_yr5: 12,
    },

    stubbles_green_manure: {
      name: 'Stubbles Followed by Green Manure',
      unit: 'ha',
      costSavings: 0,
      implementationCost: 210,
      maintenanceCost:0,

      benefits: ['Improved soil fertility', 'Reduced erosion', 'Weed suppression', 'Nitrogen fixation'],
      longTermPros: ['Enhanced soil organic matter', 'Improved water retention', 'Better soil structure', 'Reduced fertilizer needs'],
      SAIQ:['FSA28b'],
      aecs: true,
      AECSpayment_yr1: 498.49,
      AECSpayment_yr2: 278.16,
      AECSpayment_yr3: 0,
      AECSpayment_yr4: 0,
      AECSpayment_yr5: 0,
      AECS_maxarea: 20
    },

    unharvested_headlands: {
      name: 'Unharvested Conservation Headlands',
      unit: 'ha',
      costSavings: 0,
      implementationCost: 0,
      maintenanceCost:0,

      benefits: ['Biodiversity'],
      longTermPros: [],
      SAIQ:['FSA65','FSA68a','FSA68b'],
      aecs: true,
      AECSpayment_yr1: 657,
      AECSpayment_yr2: 657,
      AECSpayment_yr3: 657,
      AECSpayment_yr4: 657,
      AECSpayment_yr5: 657,
      AECS_maxarea: 5  
    },
    field_margins: {
      name: 'Grass Field Margins',
      unit: 'ha',
      costSavings: 20,
      implementationCost: 300,
      maintenanceCost:100,

      benefits: ['Wildlife habitat', 'Natural pest control', 'Pollinator support', 'Reduced spray drift'],
      longTermPros: ['Ecosystem service provision', 'Regulatory compliance', 'Enhanced farm reputation', 'Reduced input costs'],
      SAIQ:['FSA66', 'FSA48'],
      aecs: true,
      AECSpayment_yr1: 827.13,
      AECSpayment_yr2: 495.62,
      AECSpayment_yr3: 495.62,
      AECSpayment_yr4: 495.62,
      AECSpayment_yr5: 495.62,
    },

    no_till: {
      name: 'Min/No-Till Farming',
      unit: 'ha',
      costSavings: 100,
      implementationCost: 90,
      maintenanceCost:60,

      benefits: ['Reduced fuel costs', 'Time savings', 'Soil conservation', 'Moisture retention'],
      longTermPros: ['Improved soil health', 'Carbon sequestration', 'Reduced erosion', 'Enhanced water infiltration'],
      SAIQ:['FSA29a','FSA72'],
      aecs: false,
      carbon:true,
      carbonPayment_yr1: 12,
      carbonPayment_yr2: 12,
      carbonPayment_yr3: 12,
      carbonPayment_yr4: 12,
      carbonPayment_yr5: 12,
    },
    crop_rotation: {
      name: 'Crop Rotation',
      unit: 'ha',
      costSavings: 0,
      implementationCost: 0,
      maintenanceCost:0,

      benefits: ['Reduced pest pressure', 'Improved yields', 'Nutrient cycling', 'Risk diversification'],
      longTermPros: ['Enhanced soil fertility', 'Reduced disease buildup', 'Sustainable productivity', 'Market diversification'],
      SAIQ:['FSA29a','FSA31','FSA48b','FSA48c','FSA49'],
      aecs: false
    },
    hedgerows: {
      name: 'Plant Hedgerows',
      unit: 'metre',
      costSavings: 0,
      implementationCost: 0,
      maintenanceCost:0,

      benefits: ['Wind protection', 'Wildlife corridors', 'Boundary demarcation', 'Carbon storage'],
      longTermPros: ['Landscape connectivity', 'Microclimate benefits', 'Aesthetic value', 'Heritage preservation'],
      SAIQ:['FSA44'],
      aecs: true,
      AECSpayment_yr1: 7.572,
      AECSpayment_yr2: 0.372,
      AECSpayment_yr3: 0.372,
      AECSpayment_yr4: 0.372,
      AECSpayment_yr5: 0.372,
    }, 

    organic_inputs: {
      name: 'Apply Organic Matter',
      unit: 'ha',
      costSavings: 0,
      implementationCost: 0,
      maintenanceCost:0,

      benefits: ['Improved soil fertility', 'Enhanced nutrient cycling', 'Better soil structure', 'Waste utilization'],
      longTermPros: ['Sustainable soil management', 'Reduced synthetic fertilizer dependency', 'Improved soil biology', 'Carbon sequestration'],
      SAIQ:['FSA28b','FSA35b'],
      aecs: false

    },
    renewable_energy: {
      name: 'Adopt Renewable Energy',
      unit: 'ha',
      costSavings: 0,
      implementationCost: 0,
      maintenanceCost:0,

      benefits: ['Reduced carbon emissions', 'Energy independence', 'Lower long-term utility costs'],
      longTermPros: ['Resilience to energy price volatility', 'Eligible for government incentives'],
      SAIQ:['FSA74','FSA72'],
      aecs: false
    },

    ridging: {
      name: 'Ridging',
      unit: 'ha',
      costSavings: 0,
      implementationCost: 0,
      maintenanceCost:0,

  
      benefits: ['Improved drainage', 'Better root development', 'Enhanced crop yield in wet conditions'],
      longTermPros: ['Reduced waterlogging risk', 'Improved soil structure'],
      SAIQ:['FSA29d'],
      aecs: false
    },

    contour_farming: {
      name: 'Contour Farming',
      unit: 'ha',
      costSavings: 0,
      implementationCost: 0,
      maintenanceCost:0,

      benefits: ['Reduces soil erosion', 'Improves water infiltration'],
      longTermPros: ['Preserves soil fertility', 'Enhances sustainability on sloped land'],
      SAIQ:['FSA53','FSA29b'],
      aecs: false
    },

    hydrophilic_crops: {
      name: 'Grow Hydrophilic Crops',
      unit: 'ha',
      costSavings: 0,
      implementationCost: 0,
      maintenanceCost:0,

      benefits: ['Improved water efficiency', 'Better yields in wet areas'],
      longTermPros: ['Crop adaptation to climate variability', 'Efficient land use'],
      SAIQ:['FSA29d'],
      aecs: false
    },

    water_harvesting: {
      name: 'Water Harvesting',
      unit: 'ha',
      costSavings: 0,
      implementationCost: 0,
      maintenanceCost:0,

      benefits: ['Reduces dependency on external water sources', 'Enhances drought resilience'],
      longTermPros: ['Secured water supply', 'Improved crop reliability'],
      SAIQ:['FSA54'],
      aecs: false
    },

    surface_drainage: {
      name: 'Surface Drainage',
      unit: 'ha',
      costSavings: 0,
      implementationCost: 0,
      maintenanceCost:0,

      benefits: ['Prevents surface waterlogging', 'Protects crops from flood damage'],
      longTermPros: ['Improved field accessibility', 'Longer growing seasons'],
      SAIQ:['FSA29d'],
      aecs: false
    },

    subsurface_drainage: {
      name: 'Subsurface Drainage',
      unit: 'ha',
      costSavings: 0,
      implementationCost: 0,
      maintenanceCost:0,

      benefits: ['Reduces root zone saturation', 'Improves crop health and yield'],
      longTermPros: ['Boosts land productivity', 'Minimizes salinization risk'],
      SAIQ:['FSA29d'],
      aecs: false

    },

    machinery_optimisation: {
      name: 'Optimise Machinery Use & Maintenance',
      unit: 'ha',
      costSavings: 0,
      implementationCost: 0,
      maintenanceCost:0,

      benefits: ['Lower fuel and maintenance costs', 'Reduced emissions'],
      longTermPros: ['Extended machinery lifespan', 'Lower carbon footprint'],
      SAIQ : ['FSA73b','FSA18','FSA72'],
      aecs: false
    },

    intercropping: {
      name: 'Intercropping',
      unit: 'ha',
      costSavings: 0,
      implementationCost: 0,
      maintenanceCost:0,

      benefits: ['Diverse income streams', 'Better pest and weed control'],
      longTermPros: ['Improved soil health', 'Resilience to crop failure'],
      SAIQ: ['FSA27','FSA28a'],
      aecs: false
    },

    minimum_herbicide: {
      name: 'Minimise Chemical Inputs',
      unit: 'ha',
      costSavings: 0,
      implementationCost: 0,
      maintenanceCost:0,

      benefits: ['Reduced chemical input costs', 'Improved soil and water health'],
      longTermPros: ['Reduced herbicide resistance', 'Enhanced biodiversity'],
      SAIQ: ['FSA68b','FSA28c','FSA72'],
      aecs: false
    },

    crop_residue: {
      name: 'Crop Residue',
      unit: 'ha',
      costSavings: 0,
      implementationCost: 0,
      maintenanceCost:0,

      benefits: ['Increases organic matter', 'Reduces erosion and evaporation'],
      longTermPros: ['Builds soil structure', 'Boosts soil fertility over time'],
      SAIQ: ['FSA74','FSA28a', 'FSA28b','FSA36','FSA52','FSA53'],
      // aecs: true,
      // AECSpayment_yr1: 96.18,
      // AECSpayment_yr2: 96.18,
      // AECSpayment_yr3: 96.18,
      // AECSpayment_yr4: 96.18,
      // AECSpayment_yr5: 96.18,
      // AECS_maxarea: 10,
      carbon:true,
      carbonPayment_yr1: 10,
      carbonPayment_yr2: 10,
      carbonPayment_yr3: 10,
      carbonPayment_yr4: 10,
      carbonPayment_yr5: 10,


    },


    habitat_restoration: {
      name: 'Species Rich Grassland',
      costSavings: 0,
      unit: 'ha',
      implementationCost: 0,
      maintenanceCost:0,

      benefits: ['Supports pollinators and wildlife', 'Reduces input costs on marginal land'],
      longTermPros: ['Biodiversity conservation', 'Improved ecosystem services'],
      SAIQ:['FSA67'],
      aecs: true,
      AECSpayment_yr1: 109.56,
      AECSpayment_yr2: 109.56,
      AECSpayment_yr3: 109.56,
      AECSpayment_yr4: 109.56,
      AECSpayment_yr5: 109.56,
    },

    buffer_zones: {
      name: 'Natural Buffer Zones',
      unit: 'ha',
      costSavings: 0,
      implementationCost: 0,
      maintenanceCost:0,

      benefits: ['Reduces nutrient runoff', 'Improved soil and water health','Provides habitat for wildlife'],
      longTermPros: ['Improved ecosystem resilience', 'Enhanced biodiversity','Sustained soil productivity'],
      SAIQ: ['FSA65','FSA44','FSA53','FSA60','FSA64'],
      aecs: true,
      AECSpayment_yr1: 827.13,
      AECSpayment_yr2: 495.62,
      AECSpayment_yr3: 495.62,
      AECSpayment_yr4: 495.62,
      AECSpayment_yr5: 495.62,
    },


    // soil_amendment: {
    //   name: 'Soil Amendments',
    //   unit: 'ha',
    //   costSavings: 0,
    //   implementationCost: 0,
    //   maintenanceCost:0,

    //   benefits: ['Targeted soil health improvement', 'Enhanced nutrient availability', 'Better soil structure', 'pH optimization'],
    //   longTermPros: ['Sustained soil productivity', 'Reduced fertilizer dependency', 'Improved crop resilience', 'Enhanced soil biology'],
    //   SAIQ: ['FSA30'],
    //   aecs:false
    // },

    farm_waste_management: {
      name: 'Farm Waste Management',
      unit: 'ha',
      costSavings: 0,
      implementationCost: 0,
      maintenanceCost:0,

      benefits: ['Reduced disposal costs', 'Waste to resource conversion', 'Circular economy', 'Environmental compliance'],
      longTermPros: ['Resource efficiency', 'New revenue streams', 'Environmental stewardship', 'Cost stability'],
      SAIQ: ['FSA51'],
      aecs: false
    },

    precision_irrigation: {
      name: 'Irrigation Management',
      unit: 'ha',
      costSavings: 0,
      implementationCost: 0,
      maintenanceCost:0,

      benefits: ['Optimized water use', 'Reduced water costs', 'Improved crop quality', 'Drought resilience'],
      longTermPros: ['Water security', 'Climate adaptation', 'Consistent yields', 'Resource conservation'],
      SAIQ: ['FSA58', 'FSA59'],
      aecs: false

    },

    greywater_recycling: {
      name: 'Greywater Recycling',
      costSavings: 0,
      implementationCost: 0,
      maintenanceCost:0,
      benefits: ['Reduced water consumption', 'Lower water bills', 'Waste reduction', 'Resource efficiency'],
      longTermPros: ['Water independence', 'Environmental compliance', 'Cost stability', 'Circular resource use'],
      SAIQ: ['FSA61'],
      aecs: false

    },

    // ghg_monitoring: {
    //   name: 'Farm Carbon Footprint Monitoring',
    //   unit: 'ha',

    //   costSavings: 0,

    //   implementationCost: 0,
    //   benefits: ['Carbon footprint tracking', 'Emission reduction identification', 'Carbon market access', 'Sustainability reporting'],
    //   longTermPros: ['Carbon credit income', 'Climate risk management', 'Market differentiation', 'Future compliance'],
    //   SAIQ: ['FSA75'],
    //   aecs: false

    // },
    woodland: {
      name: 'Woodland Planting',
      costSavings: 0,
      unit: 'ha',
      notes:'Calculations assume this area of woodland is planted each year.',
      implementationCost: 3500,
      maintenanceCost:3950 ,
      benefits: ['Supports pollinators and wildlife', 'Improved water quality'],
      longTermPros: ['Biodiversity conservation', 'Improved ecosystem services'],
      SAIQ:['FSA67'],
      fgs: true,
      fgsPayment_yr1: 2500,
      fgsPayment_yr2: 2950,
      fgsPayment_yr3: 3400,
      fgsPayment_yr4: 3850,
      fgsPayment_yr5: 4300,

      carbon: true,
      carbonPayment_yr1: 6000,
      carbonPayment_yr2: 6000,
      carbonPayment_yr3: 6000,
      carbonPayment_yr4: 6000,
      carbonPayment_yr5: 6000,
    }
  };
  
  export const EXPLANATIONS = {
    action_nature: {
      'wildflower_strips-pollinators': 'Wildflower strips provide nectar and pollen sources throughout the growing season, supporting diverse bee, butterfly, and other pollinator populations that are essential for crop fertilisation.',
      'wildflower_strips-biodiversity': 'Wildflower strips create habitat corridors that support various insects, birds, and small mammals, increasing overall farm biodiversity and ecosystem resilience.',
      'wildflower_strips-pest_control': 'Wildflower strips support natural enemies of pests by providing them with nectar, shelter, and overwintering habitat.',
      'cover_crops-water_efficiency': 'Cover crops improve soil structure and organic matter, helping the soil hold and use water more efficiently.',
      'cover_crops-soil_compaction': 'Deep-rooted cover crops help break up compacted layers, improving infiltration and root growth.',
      'cover_crops-soil_erosion': 'Cover crops protect the soil surface from wind and water erosion.',
      'cover_crops-som': 'Growing cover crops adds root and shoot biomass that decomposes into organic matter.',
      'cover_crops-soc': 'Plant biomass decomposes and converts into stable organic carbon in the soil.',
      'cover_crops-soil_fertility': 'Cover crops improve nutrient cycling and may include nitrogen-fixing species that enrich soil fertility.',

      'agroforestry-carbon_storage': 'Trees and woody plants in agroforestry systems capture and store carbon in their biomass and in soil, helping mitigate climate change while providing farm benefits.',
      'agroforestry-biodiversity': 'Agroforestry creates diverse habitats at multiple levels (canopy, understory, ground) supporting various species and creating wildlife corridors across the landscape.',
      'agroforestry-soil_fertility': 'Tree litter, shade, and nutrient recycling in agroforestry enhance fertility and protect soil from depletion.',
      'agroforestry-som': 'Leaf litter and root turnover from trees build up soil organic matter.',
  
      // ✅ New missing explanations below:
  
      'field_margins-pollinators': 'Field margins provide year-round flowering and nesting habitat for pollinators, supporting their survival near crops.',
      'field_margins-pest_control': 'Field margins support beneficial insects such as predatory beetles and parasitic wasps that help control crop pests.',
  
      'no_till-water_efficiency': 'No-till practices help maintain soil moisture by reducing evaporation and improving water infiltration.',
      'no_till-soil_erosion': 'No-till farming protects soil surface from erosion by leaving crop residue intact.',
      'no_till-soil_compaction': 'Over time, no-till promotes better soil structure and reduces compaction from repeated tillage.',
      'no_till-soil_fertility': 'Soil fertility improves in no-till systems due to enhanced microbial activity and organic matter buildup.',
      'no_till-soil_biology': 'Reduced disturbance allows soil biological communities to thrive, including fungi and microbes important for plant health.',
      'no_till-som': 'Avoiding soil disturbance preserves existing organic matter and encourages biological activity that builds SOM.',
      'no_till-soc': 'By minimising soil disturbance, no-till prevents carbon loss through erosion and decomposition.',

      'crop_rotation-pest_control': 'Rotating crops interrupts pest and disease cycles by removing continuous hosts.',
      'crop_rotation-som': 'Rotating crops improves soil microbial activity and adds diverse organic residues, boosting overall SOM.',
      'crop_rotation-soc': 'Different crops contribute diverse root residues, enhancing carbon input and storage in soil.',
      'crop_rotation-nutrient_efficiency': 'Diverse crop rotations improve nutrient cycling and reduce reliance on fertilisers.',
      'crop_rotation-soil_fertility': 'Rotations help replenish nutrients and avoid depletion from monoculture systems.',
      'crop_rotation-soil_compaction': 'Rotations that include deep-rooted crops improve soil structure and reduce compaction.',
      'crop_rotation-soil_biology': 'Crop diversity supports diverse soil organisms, enhancing soil biology and resilience.',
  
      'hedgerows-biodiversity': 'Hedgerows offer food, shelter, and corridors for a wide range of wildlife, increasing on-farm biodiversity.',
      'hedgerows-carbon_storage': 'Hedgerows store carbon in biomass and improve long-term carbon sequestration.',
      'hedgerows-water_efficiency': 'Hedgerows reduce wind speed and improve microclimates, enhancing water use efficiency.',
      'hedgerows-water_quality': 'Hedgerows filter runoff and trap sediments and nutrients before they reach water bodies.',
      'hedgerows-soil_erosion': 'They act as physical barriers that reduce surface runoff and soil erosion.',
      'hedgerows-pest_control': 'Hedgerows support predatory insects and birds that suppress crop pests.',
      'hedgerows-pollinators': 'Flowering plants in hedgerows provide nectar and nesting habitat for pollinators.',
      'hedgerows-soc': 'Woody plants in hedgerows store carbon both above ground in wood and below ground in roots and soil.',

  
      'organic_inputs-soil_fertility': 'Organic matter releases nutrients slowly and improves soil structure and fertility.',
      'organic_inputs-som': 'Adding compost, manure, or other organic materials directly increases the quantity of organic matter in the soil.',
      'organic_inputs-soil_biology': 'Manure and compost stimulate microbial activity and biodiversity in the soil.',
      'organic_inputs-reduced_waste': 'Using farm or food waste as organic inputs reduces waste and enhances nutrient recycling.',

      'renewable_energy-emissions': 'Switching to renewable energy reduces on-farm fossil fuel use and greenhouse gas emissions.',
  
      'ridging-soil_erosion': 'Ridging creates raised beds that reduce water runoff and soil erosion on slopes.',
      'ridging-water_efficiency': 'It improves water drainage and reduces pooling, making water use more efficient.',
  
      'contour_farming-landscape_resilience': 'Contour farming slows runoff and improves resilience to heavy rain events.',
      'contour_farming-nutrient_efficiency': 'It prevents nutrient loss by reducing erosion and allowing better root access.',
      'contour_farming-water_quality': 'Reduces sediment and nutrient transport into waterways.',
      'contour_farming-soil_erosion': 'Farming along contours minimises water-induced soil loss.',
      'contour_farming-water_efficiency': 'Improves infiltration and water retention by directing water flow.',
  
      'hydrophilic_crops-landscape_resilience': 'Hydrophilic crops can tolerate wet conditions, improving resilience to flooding.',
      'hydrophilic_crops-water_quality': 'These crops reduce runoff and filter nutrients, improving downstream water quality.',
      'hydrophilic_crops-soil_erosion': 'Dense root systems reduce erosion on wetter land.',
      'hydrophilic_crops-water_efficiency': 'They make efficient use of available soil water in moist zones.',
      'hydrophilic_crops-soil_compaction': 'Deep-rooted hydrophilic species can break up compacted soils.',
  
      'water_harvesting-soil_erosion': 'Capturing water reduces uncontrolled surface flow that causes erosion.',
      'water_harvesting-water_efficiency': 'Water harvesting ensures more water is available during dry periods.',
      'water_harvesting-reduced_waste': 'Captured water is reused, reducing wasted runoff.',
  
      'surface_drainage-soil_erosion': 'Improves water movement across fields, preventing erosion from pooling.',
      'surface_drainage-water_efficiency': 'Facilitates drainage after rainfall, improving access and reducing stress.',
      'surface_drainage-water_quality': 'Helps filter and manage runoff water before it reaches water bodies.',
  
      'subsurface_drainage-soil_erosion': 'Drains excess water that could lead to erosion.',
      'subsurface_drainage-water_efficiency': 'Maintains optimal root zone moisture by removing excess water.',
      'subsurface_drainage-water_quality': 'Reduces nutrient leaching and improves drainage quality.',
  
      'machinery_optimisation-reduced_waste': 'Efficient machinery use minimises input waste and reduces unnecessary fuel use.',
      'machinery_optimisation-emissions': 'Well-maintained machinery emits fewer pollutants and operates more efficiently.',
  
      'intercropping-soil_fertility': 'Legumes in intercrops fix nitrogen, improving fertility.',
      'intercropping-soil_erosion': 'Mixed crop coverage protects soil from erosion.',
      'intercropping-som': 'Growing multiple crops together increases total biomass inputs and supports diverse soil organisms, enhancing SOM.',

      
  
      'minimum_herbicide-nutrient_efficiency': 'Reducing chemical use supports healthier root development and nutrient uptake.',
      'minimum_herbicide-water_quality': 'Limits runoff of harmful chemicals into water sources.',
      'minimum_herbicide-soil_fertility': 'Maintains natural nutrient cycles without disrupting microbial balance.',
      'minimum_herbicide-soil_biology': 'Fewer chemicals support diverse soil microbes and fauna.',
      'minimum_herbicide-pollinators': 'Reduces harm to bees and other beneficial insects.',
      'minimum_herbicide-pest_control': 'Maintains populations of beneficial predators sensitive to herbicides.',
      'minimum_herbicide-som': 'Reducing chemical inputs supports beneficial soil organisms that help build and maintain SOM.',

      'crop_residue-soil_biology': 'Residue provides continuous organic input to feed soil organisms.',
      'crop_residue-soil_erosion': 'Covers soil surface and prevents wind and rain erosion.',
      'crop_residue-soil_compaction': 'Improves soil structure, reducing compaction over time.',
      'crop_residue-soil_fertility': 'Adds nutrients back into the soil as it decomposes.',
      'crop_residue-water_efficiency': 'Mulching effect helps retain soil moisture.',
      'crop_residue-reduced_waste': 'Residue reuse avoids waste and closes nutrient loops.',
      'crop_residue-som': 'Leaving crop residues on fields adds organic material that feeds soil microbes and builds SOM.',
      'crop_residue-soc': 'Decomposing residues add carbon to the soil, supporting long-term organic carbon buildup.',

      'habitat_restoration-landscape_resilience': 'Diverse plant species improve soil and water dynamics, helping the landscape recover from extreme weather.',
      'habitat_restoration-carbon_storage': 'Natural vegetation captures and stores carbon long-term.',
      'habitat_restoration-biodiversity': 'Increases wildlife habitat and restores ecosystem functions.',
      'habitat_restoration-soc': 'Deep-rooted perennial plants deposit carbon into the soil over long periods.',

      'woodland-landscape_resilience': 'Restored habitat buffers against extreme weather impacts.',
      'woodland-carbon_storage': 'Natural vegetation captures and stores carbon long-term.',
      'woodland-biodiversity': 'Increases wildlife habitat and restores ecosystem functions.',
      'woodland-soc': 'Trees sequester large amounts of carbon in biomass and enrich soil carbon through leaf litter and root decay.',


      'buffer_zones-landscape_resilience': 'Buffers improve natural defense against flood and drought impacts.',
      'buffer_zones-biodiversity': 'Provide continuous habitat for a wide range of organisms.',
      'buffer_zones-pollinators': 'Support nesting and feeding of pollinator species.',
      'buffer_zones-pest_control': 'Shelter beneficial species that help manage pests.',
      'buffer_zones-water_quality': 'Filter runoff and trap sediment before it reaches water sources.',
      'buffer_zones-water_efficiency': 'Slow water movement and promote infiltration into soil.',

      // 'soil_amendment-soil_fertility': 'Targeted amendments address specific nutrient deficiencies and pH imbalances.',
      // 'soil_amendment-soc': 'Amendments improve soil structure and chemistry, promoting carbon stabilisation and accumulation.',
      // 'soil_amendment-som': 'Improving soil chemical and physical conditions enhances the buildup and stabilisation of organic matter.',

      // 'soil_amendment-soil_biology': 'Amendments provide food and habitat for beneficial soil microorganisms.',
      // 'soil_amendment-soil_compaction': 'Organic amendments improve soil structure and reduce compaction.',
      // 'soil_amendment-nutrient_efficiency': 'Proper amendments optimize nutrient availability and uptake.',
      'farm_waste_management-reduced_waste': 'Systematic approach to reduce, reuse, and recycle farm waste.',
      'farm_waste_management-emissions': 'Proper waste handling reduces methane and other emissions.',
      'farm_waste_management-water_quality': 'Prevents waste contamination of water sources.',
      'farm_waste_management-som': 'Recycling farm residues returns valuable organic material to the soil, enriching SOM.',
  
      'precision_irrigation-water_efficiency': 'Optimizss water application timing and amounts.',
      'precision_irrigation-nutrient_efficiency': 'Prevents nutrient leaching through precise water management.',
      'precision_irrigation-soil_erosion': 'Controlled application reduces erosive runoff.',
      'precision_irrigation-water_quality': 'Minimises runoff and nutrient leaching.',

      'greywater_recycling-water_efficiency': 'Reuses water that would otherwise be wasted.',
      'greywater_recycling-reduced_waste': 'Converts waste water into a useful resource.',
      'greywater_recycling-water_quality': 'Reduces discharge of untreated water.',

      'ghg_monitoring-emissions': 'Tracking enables identification of emission reduction opportunities.',
      'ghg_monitoring-carbon_storage': 'Monitors carbon sequestration activities and effectiveness.',

      'stubbles_green_manure-soc': 'Green manure crops add fresh organic carbon that increases soil carbon stocks when decomposed.',
      'stubbles_green_manure-som': 'Incorporating green manure crops introduces fresh organic inputs, enriching SOM levels.',
      'stubbles_green_manure-soil_erosion': 'The green manure cover protects the soil surface from wind and water erosion by providing ground cover and stabilizing the soil with roots.',
      'stubbles_green_manure-biodiversity':'Introducing diverse green manure crops increases plant species diversity and provides habitat and food resources for beneficial soil organisms and wildlife.',
      'stubbles_green_manure-soil_fertility': 'Green manure crops fix nitrogen (if legumes) and add organic nutrients to the soil, improving nutrient availability for subsequent crops.',
      'stubbles_green_manure-soil_compaction':'The root systems of green manure crops help break up compacted layers and improve soil structure, enhancing aeration and water infiltration.',
      
      'unharvested_headlands-biodiversity':'Unharvested conservation headlands provide undisturbed habitats that support a wide range of plant and animal species, enhancing on-farm biodiversity.',
      'unharvested_headlands-pollinators': 'These areas offer continuous floral resources and nesting sites for pollinators, supporting their populations throughout the season.',
      'unharvested_headlands-pest_control':'By sheltering beneficial insects and predators, unharvested headlands help naturally regulate pest populations in adjacent crops.'

    },
  
    nature_resilience: {
      'pollinators-yield': 'Abundant pollinators ensure better crop fertilisation and fruit set, directly increasing yields for pollinator-dependent crops like fruits, vegetables, and nuts. Additionally, natural pest predators as adults feed on nectar and pollen.',
      'pollinators-cost': 'Healthy pollinator populations reduce the need for artificial pollination services and support better natural crop set.',
  
      'soil_health-yield': 'Healthy soils provide better nutrient availability, water retention, and root development, leading to stronger plants and higher crop yields.',
      'soil_health-cost': 'Healthy soils require fewer external inputs like fertilisers and pesticides, reducing production costs while maintaining productivity.',
  
      'water_efficiency-shocks': 'Efficient water use improves drought resilience and reduces crop losses during dry periods.',
      'water_efficiency-cost': 'Better water management reduces irrigation and pumping costs.',
      'water_efficiency-yield': 'Adequate soil moisture from efficient use supports higher and more reliable yields.',
  
      'biodiversity-yield': 'Biodiversity supports ecosystem functions like pollination and pest control that boost yield.',
      'biodiversity-price': 'High biodiversity is increasingly valued in sustainable product markets.',
      'biodiversity-income': 'Biodiverse systems support diversified production (e.g., honey, fruit, timber).',
      'biodiversity-shocks': 'Greater species diversity increases farm resilience to disease, pests, and weather variability.',
  
      'carbon_storage-price': 'Carbon sequestration can increase product value in low-carbon or eco-certified markets.',
      'carbon_storage-income': 'Storing carbon opens new income sources from carbon credits.',
  
      'emissions-price': 'Lower emissions can command better prices in climate-conscious markets.',
      'emissions-income': 'Emission reductions may qualify for incentive schemes or carbon markets.',
  
      'pest_control-yield': 'Natural pest regulation prevents crop loss without needing chemicals.',
      'pest_control-cost': 'Biological control reduces the need for expensive pesticides.',
      'pest_control-shocks': 'Integrated pest systems are more stable under shifting climate and pest conditions.',
  
      'water_quality-price': 'High water quality can enhance brand reputation and marketability.',
      'water_quality-yield': 'Clean water improves crop performance and reduces contamination risk.',
  
      'nutrient_efficiency-cost': 'Better nutrient uptake reduces input waste and fertiliser costs.',
      'nutrient_efficiency-yield': 'Improved efficiency means nutrients are used for stronger crop growth.',
      'nutrient_efficiency-shocks': 'Efficient systems adapt better to environmental stresses.',
      'nutrient_efficiency-income': 'Healthy crops and input savings can increase overall income.',
  
      'som-cost': 'Soil organic matter reduces need for fertilisers by holding nutrients and water.',
      'som-yield': 'Improved structure and biology in SOM-rich soils supports high productivity.',
      'som-price': 'Sustainable practices can yield premium prices.',
      'som-income': 'Resilient, productive systems create more consistent and diverse income.',
  
      'soc-cost': 'Increased soil organic carbon improves soil structure and nutrient retention, reducing the need for costly fertilisers and soil amendments.',
      'soc-yield': 'Higher soil organic carbon enhances soil fertility and moisture retention, leading to improved crop growth and increased yields.',
      'soc-price': 'Products grown on soils with improved carbon levels can qualify for premium markets focused on sustainability and carbon-friendly practices.',
      'soc-income': 'Selling soil carbon credits creates an additional revenue stream, supplementing traditional farm income and encouraging long-term soil stewardship.',

      'soil_fertility-cost': 'Fertile soils require fewer amendments and boost efficiency.',
      'soil_fertility-yield': 'Fertility directly impacts yield potential and crop success.',
      'soil_fertility-shocks': 'Healthy soil resists degradation under extreme weather.',
  
      'soil_compaction-yield': 'Looser soils support root growth and better crop access to water and nutrients.',
      'soil_compaction-shocks': 'Less compacted soils absorb water better, improving resilience to flooding or drought.',
  
      'soil_erosion-yield': 'Preserving topsoil prevents yield loss and improves growing conditions.',
      'soil_erosion-shocks': 'Controlling erosion stabilizes fields against climate extremes.',
  
      'soil_biology-yield': 'Soil organisms improve nutrient availability and disease suppression, raising yields.',
      'soil_biology-shocks': 'Biological diversity in soil helps buffer environmental stresses.',
  
      'landscape_resilience-yield': 'Resilient landscapes buffer crops from wind, water, and temperature extremes.',
      'landscape_resilience-shocks': 'Improved landscape function mitigates flooding, drought, and storm impact.',
  
      'reduced_waste-cost': 'Efficient input use and reuse reduce unnecessary costs.'
    }
  };

  // natureOutcomes: [
  //   { id: 'pollinators', name: 'High Pollinator Abundance', color: '#6B7280', connects: ['yield','cost'] },
  //   { id: 'water_efficiency', name: 'Water Efficiency', color: '#6B7280', connects: ['shocks','cost','yield'] },
  //   { id: 'biodiversity', name: 'Overall Species Diversity', color: '#6B7280', connects: ['yield', 'price','income','shocks'] },
  //   { id: 'carbon_storage', name: 'Increased Carbon Sequestration', color: '#6B7280', connects: ['price', 'income'] },
  //   { id: 'emissions', name: 'Reduce Fossil Fuel Use', color: '#6B7280', connects: ['price', 'income'] },
  //   { id: 'pest_control', name: 'Natural Predator Abundance', color: '#6B7280', connects: ['yield', 'cost','shocks'] },
  //   { id: 'water_quality', name: 'Improved Water Quality', color: '#6B7280', connects: ['price','yield'] },
  //   { id: 'nutrient_efficiency', name: 'Improved Nutrient Use Efficiency', color: '#6B7280', connects: ['cost','yield','shocks','income'] },
  //   { id: 'soc', name: 'Increased Soil Organic Carbon', color: '#6B7280', connects: ['cost','yield','price','income'] },
  //   { id: 'som', name: 'Increased Soil Organic Matter', color: '#6B7280', connects: ['cost','yield','price','income'] },
  //   { id: 'soil_fertility', name: 'Increased Soil Fertility', color: '#6B7280', connects: ['cost','yield','shocks'] },
  //   { id: 'soil_compaction', name: 'Reduced Soil Compaction', color: '#6B7280', connects: ['yield','shocks'] },
  //   { id: 'soil_erosion', name: 'Reduced Soil Erosion', color: '#6B7280', connects: ['yield','shocks'] },
  //   { id: 'soil_biology', name: 'Enhance Active Soil Biology', color: '#6B7280', connects: ['yield','shocks'] },
  //   { id: 'landscape_resilience', name: 'Landscape Resilience to Extreme Weather', color: '#6B7280', connects: ['yield','shocks'] },
  //   { id: 'reduced_waste', name: 'Reduce Waste', color: '#6B7280', connects: ['cost'] },